import { getCurrentTenant } from "./tenantConfig";

const tenant = getCurrentTenant();

const KEYCLOAK_CONFIG = {
  realmUrl: `${tenant?.keycloakHost}/realms/${tenant?.projectCode}`,
  clientId: "DefaultClient",
  redirectUri: window.location.origin + "/login",
};

export default KEYCLOAK_CONFIG;